import React from 'react';
import { Translate } from '../contexts/Language';

export const AuthLoading = () => (
  <div className="app-loading auth">
    <div className="wrapper-page">
      <div className="card">
        <div className="card-body text-center">
          <h4 className="card-title font-16 mt-0">{Translate('Checking Authorization')}</h4>
          <p className="card-text">{Translate('Checking user information and loading content, please wait...')}</p>
          <div className="spinner-border text-info" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export const FetchLoading = () => (
  <div className="app-loading fetch">
    <div className="wrapper-page">
      <div className="card">
        <div className="card-body text-center">
          <h4 className="card-title font-16 mt-0">{Translate('Loading Content')}</h4>
          <p className="card-text">{Translate('Checking user information and loading content, please wait...')}</p>
          <div className="spinner-border text-info" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      </div>
    </div>
  </div>
);
